import { Directive, ElementRef, HostListener, Input  } from '@angular/core';
import {NgControl} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appNumbersonly]'
})
export class NumbersonlyDirective {
  maxlength = 6;
  constructor(private ngControl : NgControl,private toastr : ToastrService) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
  let clean = '';
  clean = value.replace(/[^0-9]/, '');
  if (clean) {
    if (clean.length > this.maxlength) {
    }
    clean = clean.slice(0, this.maxlength);
  }
    this.ngControl.control.patchValue(clean);
  }
}
